export default __webpack_public_path__ + "static/media/new.f165db69.svg";